import Repository from './../Repository';

const resource = 'admin/teams';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    settings(id)        {return Repository.get(`${resource}/${id}/settings`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    update(payload, id) {return Repository.put(`${resource}/${id}`, payload);},
    delete(id)          {return Repository.delete(`${resource}/${id}`);},
    permissions(payload) {return Repository.put(`${resource}/permissions/update`, payload);},
    quizzes(payload)     {return Repository.put(`${resource}/toggle/quiz`, payload);},
}